import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtUICoreOverlayModule } from './../../../core/core.module';
import { TimePickerDropdownComponent } from './time-picker-dropdown.component';

@NgModule({
  exports: [TimePickerDropdownComponent],
  imports: [CommonModule, RtUICoreOverlayModule, TimePickerDropdownComponent],
})
export class TimePickerDropdownModule {}
export { TimePickerDropdownComponent } from './time-picker-dropdown.component';
